import React, { useEffect } from "react";
import DropdownSection from "./DropdownSection";
import notes from "./notes";
import "./Resume.css"
import AOS from 'aos';
import 'aos/dist/aos.css';


function Resume() {

   useEffect(() => {

      document.title =
         "Resume | Amresh Kumar";

      const metaDescription =
         document.querySelector(
            'meta[name="description"]'
         );

      if (metaDescription) {

         metaDescription.setAttribute(
            "content",
            "View the resume of Amresh Kumar, Full Stack Developer specializing in React.js, Django, Node.js and scalable web applications."
         );

      }

   }, []);

   useEffect(() => {
      AOS.init({
         duration: 500,
         once: false,
         mirror: true,        // Optional: animate when scrolling up too
         easing: 'ease-in-out'
      });
   });
   return (
      <div className="wrapper">
         <div className="resume-title wid-50 arrange-left" data-aos="fade-down"
            data-aos-duration="1000">
            <h1>My Resume</h1>
         </div>
         <div className="App wid-50 arrange-left" data-aos="fade-up"
            data-aos-duration="1000">
            {notes.map(noteItem => (
               <DropdownSection
                  key={noteItem.key}
                  title={noteItem.title}
                  content={noteItem.content}
               />
            ))}
         </div>
      </div>

   );
}
export default Resume;